import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { gallery } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Gallery() {
  const [index, setIndex] = useState(0);
  const total = gallery.length;
  const goTo = (next: number) => {
    setIndex((next + total) % total);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      goTo(index - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      goTo(index + 1);
    }
  };
  const current = gallery[index];
  return <section className="w-full bg-blue-900 py-16 text-white md:py-24" data-id="element-111" data-mp="2um540yk2gv05">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-112" data-mp="2uktyouaz3f6x">
        <header className="mx-auto max-w-narrow text-center" data-id="element-113" data-mp="26vhuk8ui5xbh">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-blue-200" data-id="element-114" data-mp="21yhjfjisq4di">
            Mira los mapas por dentro
          </p>
          <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight md:text-5xl" data-id="element-115" data-mp="ragngwlwz5dn">
            Así se ve cada ejercicio
          </h2>
        </header>

        <div role="group" aria-roledescription="carrusel" aria-label="Galería de mapas visuales" tabIndex={0} onKeyDown={handleKeyDown} className="relative mt-12 rounded-2xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-400" data-id="element-116" data-mp="112w3hodnhjvw">
          <div className="overflow-hidden rounded-2xl" data-id="element-117" data-mp="demq9aui64gd">
            <motion.div className="flex cursor-grab active:cursor-grabbing" animate={{
            x: `-${index * 100}%`
          }} transition={{
            duration: 0.3,
            ease
          }} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.12} onDragEnd={(_, info) => {
            if (info.offset.x < -60) goTo(index + 1);
            if (info.offset.x > 60) goTo(index - 1);
          }} data-id="element-118" data-mp="hdc392bmpjzh">
              {gallery.map((item, itemIndex) => <figure key={item.title} className="w-full shrink-0" aria-hidden={itemIndex !== index} data-id="element-119" data-mp="3pw996ks6e0f8" data-mpi={itemIndex}>
                  <img src={item.image} alt={`Mapa visual de ${item.title}: músculos, planos anatómicos y errores comunes`} className="pointer-events-none w-full rounded-2xl bg-white" draggable={false} loading={itemIndex === 0 ? 'eager' : 'lazy'} data-id="element-120" data-mp="2q01maiqyms3" />
                </figure>)}
            </motion.div>
          </div>

          <button type="button" onClick={() => goTo(index - 1)} aria-label="Mapa anterior" className="absolute left-2 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-blue-800 shadow-lift transition-colors duration-150 ease-calm hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-300 md:-left-5 md:h-12 md:w-12" data-id="element-121" data-mp="2seiv4jah45mj">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-122" data-mp="tytj1bzinpo4" />
          </button>
          <button type="button" onClick={() => goTo(index + 1)} aria-label="Mapa siguiente" className="absolute right-2 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-blue-800 shadow-lift transition-colors duration-150 ease-calm hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-300 md:-right-5 md:h-12 md:w-12" data-id="element-123" data-mp="xz3o8mfhic1x">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-124" data-mp="17rzyzspd9zb" />
          </button>
        </div>

        <div className="mx-auto mt-7 max-w-narrow text-center" aria-live="polite" data-id="element-125" data-mp="67xklw0k1w7w">
          <p className="font-display text-xl font-extrabold tracking-tight md:text-2xl" data-id="element-126" data-mp="lgrhj2tyerls">
            {current.title}
          </p>
          <p className="mt-2 text-blue-100" data-id="element-127" data-mp="gp9rvaxdsdg4">{current.caption}</p>
        </div>

        <div className="mt-7 flex items-center justify-center gap-3" data-id="element-128" data-mp="bqq4d6352tln">
          {gallery.map((item, itemIndex) => <button key={item.title} type="button" onClick={() => goTo(itemIndex)} aria-label={`Ver ${item.title}`} aria-current={itemIndex === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-calm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-400 ${itemIndex === index ? 'w-8 bg-white' : 'w-2.5 bg-white/35 hover:bg-white/60'}`} data-id="element-129" data-mp="7qo2avthry5u" data-mpi={itemIndex} />)}
        </div>

        <p className="mt-6 text-center text-sm text-blue-200" data-id="element-130" data-mp="3g33i06ut58hk">
          Desliza o usa las flechas — {index + 1} de {total} mapas de muestra
        </p>
      </div>
    </section>;
}